import styled from '@emotion/styled'

export const EmptyScreenWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  justify-self: center;
`
